/**
 * 取登录上下文的 Hook。
 * 单独一个文件是为了配合 React Fast Refresh：
 * 组件文件里只导出组件，Hook 放这里，热更新时不会整页刷新。
 */
import { useContext } from 'react';
import { AuthContext, type AuthState } from '@/lib/auth/auth-store';

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth 必须在 <AuthProvider> 内部使用');
  }
  return context;
}

/**
 * 取当前门店 ID。绝大多数接口都要传 storeId，页面里这样用：
 *   const storeId = useCurrentStoreId();
 * 未登录或门店还没加载完时返回 null，此时查询应该 disabled。
 */
export function useCurrentStoreId(): string | null {
  return useAuth().currentStore?.id ?? null;
}
